<template>
  <input
    v-bind="$attrs"
    v-model="proxyValue"
    class="hkl-input-box"
    type="text"
    @change="(e) => onChange(e.target.value)"
    v-on="proxyListeners"
  >
</template>
<script>
import lodash from 'lodash'
import { ref } from 'vue-demi'

export const SOURCE = 'value'
export const EVENT = 'change'

/**
 * @type {import('vue').Component}
 */
const HKLInput = {
  name: 'HKLInput',
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: [SOURCE],
  setup () {
    const realValue = ref('')
    return { realValue }
  },
  computed: {
    proxyValue: {
      get () { return this[SOURCE] },
      set (newValue) {
        this.realValue = newValue
        this.onChange(this.realValue)
      },
    },
    proxyAttrs: {
      get () {
        const proxyValue = this.$attrs
        return this.attrsProcess(proxyValue)
      },
    },
    proxyListeners: {
      get () {
        const self = this
        let proxyListeners = this.$listeners
        const keydownFn = this.$listeners.keydown
        const keydownKeys = Object.keys(proxyListeners)
          .filter((event) => /^keydown\..+$/.test(event))
          .map((event) => event.replace(/^keydown\./, ''))
        proxyListeners.keydown = (e) => {
          const key = keydownKeys.find((key) => key === e.key)
          const fn = key ? proxyListeners[`keydown.${key}`] : keydownFn
          return (fn || (() => {}))(e)
        }
        const customBlurFn = lodash.has(this.$listeners, 'blur') ? this.$listeners.blur : () => {}
        // Reset Input component change event, otherwise it will trigger twice
        proxyListeners = Object.assign({}, proxyListeners, {
          [EVENT]: () => {},
          blur: (e) => {
            const val = e.target.value.trim()
            self.proxyValue = val
            customBlurFn(e)
          },
        })
        return this.listenerProcess(proxyListeners)
      },
    },
  },
  methods: {
    /**
     * @param {String} val
     */
    onChange (val) {
      this.$emit(EVENT, val)
    },
    attrsProcess (val) {
      return val
    },
    listenerProcess (val) {
      return val
    },
  },
}

export default HKLInput
</script>

<style lang="scss" scoped>
input.hkl-input-box {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  &.h42 {
    height: 42px;
  }
}
input.hkl-input-with-95 {
  width: 95%
}
</style>
